<template>
  <a
    href=""
    class="btn registration_next"
    :style="{ backgroundColor: color, color: textColor }"
    v-bind:class="{ outlined: mode === 'outline' }"
  >
    <slot></slot>
    <i v-if="loading" class="fa fa-spin fa-spinner" style="color: white"></i>
  </a>
</template>

<script>
export default {
  props: {
    color: { type: String, required: false, default: "" },
    textColor: { type: String, required: false, default: "" },
    mode: { type: String, required: false, default: "" },
    loading: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped>
.outlined {
  border: 2px solid #0062ff;
  background-color: white;
  color: #0062ff;
}
.outlined:hover {
  color: black;
}
</style>
